const type = {
  base: 'Helvetica',
  bold: 'Helvetica-Bold',
  emphasis: 'Helvetica-LightOblique',
};

const size = {
  h1: 38,
  h2: 34,
  h3: 30,
  h4: 26,
  h5: 20,
  h6: 19,
  input: 18,
  label: 17,
  regular: 14,
  medium: 14,
  small: 12,
  tiny: 8.5,
};

const style = {
  p: {
    fontFamily: type.base,
    fontSize: size.regular,
    fontWeight: 400,
    lineHeight: 1.5,
  },
  h5: {
    fontFamily: type.base,
    fontSize: size.h5,
    fontWeight: 400,
  },
  tab: {
    fontFamily: type.base,
    fontWeight: 'bold',
    fontSize: size.regular,
  },
};

export default {
  type,
  size,
  style,
};
